import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import { SubmittableForm } from '@fino-ui/forms';
import { FinoInputModule } from '@fino-ui/input';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';
import { PleaseBePatientComponent } from '../../../../components/please-be-patient/please-be-patient.component';

@Component({
  selector: 'app-fom-email',
  templateUrl: './fom-email.component.html',
  styleUrl: './fom-email.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    PleaseBePatientComponent,
    FormsModule,
    ReactiveFormsModule,
    FinoInputModule,
    ButtonModule,
  ],
})
export class FomEmailComponent
  extends BaseModalComponent<{ fomEmail: string }, string>
  implements OnInit
{
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  ngOnInit(): void {
    this.form.setValue({ fomEmail: this.fomEmail });
  }

  fomEmail: string;

  form = new SubmittableForm({
    fomEmail: new FormControl('', [Validators.required, Validators.email]),
  });

  abort() {
    this.close();
  }

  get formNotTouched() {
    return this.form.pristine || this.form.invalid;
  }

  submit() {
    this.result = this.form.controls.fomEmail.value;
    this.close();
  }
}
